import { render, staticRenderFns } from "./medidaneumaticosxsector.vue?vue&type=template&id=942c6b6a"
import script from "./medidaneumaticosxsector.vue?vue&type=script&lang=js"
export * from "./medidaneumaticosxsector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports